type GradientOptions = {
  offset: string
  dataKey: string
  opacity: number
}
type ChartGradientProps = {
  gradientId: string
  start: GradientOptions
  stop: GradientOptions
}
function ChartGradient(props: ChartGradientProps) {
  const { gradientId, start, stop } = props
  return (
    <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
      <stop
        offset={start.offset}
        stopColor={`var(--color-${start.dataKey})`}
        stopOpacity={start.opacity}
      />
      <stop
        offset={stop.offset}
        stopColor={`var(--color-${stop.dataKey})`}
        stopOpacity={stop.opacity}
      />
    </linearGradient>
  )
}
export default ChartGradient
